module.exports = __webpack_public_path__ + "img/flex5_5_Extended-front.16136da3.jpg";